export default __webpack_public_path__ + "56c8aa1fcce974b1b51571ac6f72bf01.png";